import * as Yup from 'yup';

import { yupPasswordSchema } from '/b2b/common/helpers/Password';

export const changePasswordSchema = Yup.object().shape({
    password: Yup.string().required(),
    newPassword: yupPasswordSchema.clone().required(),
    confirmNewPassword: Yup.string()
        .oneOf([Yup.ref('newPassword')], 'password.validations.notMatching')
        .required(),
});
